import { Button, Space } from "antd";
import { useNavigate } from "react-router-dom";
import DeniedImg from "../assets/images/access-denied.png";
import { CONSTANT } from "../config/Constant";
import { useDispatch } from "react-redux";
import { setIsRestricted } from "../features/auth/authSlice";

const RestrictedAccessPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setIsRestricted(false));
    navigate(CONSTANT.DASHBOARD_REDIRECT_PATH);
  };

  return (
    <section className="section pagenotfound__section accessDeniedPage">
      <div className="content">
        <h1>Oops!</h1>
        <h2>Access Denied</h2>
        <p>Please contact your administrator for more details.</p>
      </div>
      <div className="notFoundImg">
        <img src={DeniedImg} alt="Access Denied" />
      </div>
      <Space size="large" className="mt-30">
        <Button size="large" type="primary" onClick={() => handleClick()}>
          Go to main page
        </Button>
      </Space>
    </section>
  );
};

export default RestrictedAccessPage;
